import React, { useEffect, useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import TransactionsSidebar from "../components/TransactionsSidebar";
import { ordersActions, paymentsActions, useSelector } from "inbooma-api";
import { Biscuit, FormatHelper, getAllUrlParams } from "../../../../utils";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import TransactionsTopBar from "./TransactionsTopBar";
import { isViewVisible } from "../../../../utils/ViewSettings";
import SortNav from "../../../components/SortNav";
import NextPageBtn from "../../../components/NextPageBtn";
import TransactionsList from "./TransactionList";
import moment from "moment";
import { $, _ } from "../../../../../vendor";
import Paginator from "../../../components/paginator";

const TransactionsView = (props) => {
  const currentUrl = new URL(window.location.href);
  let language = Biscuit.get("user.lang").replace("-", "_");
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const allUrlParamsClone = { ...allUrlParams };
  allUrlParams?.location_name !== undefined && delete allUrlParams.location_name;
  allUrlParams?.payment_method_name !== undefined && delete allUrlParams.payment_method_name;
  allUrlParams?.payment_status_name !== undefined && delete allUrlParams.payment_status_name;
  const [initialized, setInitialized] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const [sort, setSort] = useState({
    sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "payment_date",
    direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "desc",
  });
  const paginationLimit = 100;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });
  const [wallets, setWallets] = useState({
    saldo: 0,
    wallet_transactions: [],
  });
  const [walletsPending, setWalletsPending] = useState(false);
  const _wallets = useSelector((state) => state.payments_data.transactions);

  const [ordersPending, setOrdersPending] = useState(false);
  const _orders = useSelector((state) => state.orders.orders);
  const _queryState = {
    timeStamp: 0,
    value: "",
  };
  const [locationName, setLocationName] = useState("");
  const [filter, setFilter] = useState(function () {
    let t = {
      limit: paginationLimit,
      page: 1,
      sort: sort.sort,
      direction: sort.direction,
    };
    if (searchParams.get("location_id") !== null) {
      t.location_id = searchParams.get("location_id");
    }
    if (searchParams.get("payment_type") !== null) {
      t.payment_type = searchParams.get("payment_type");
    }
    if (searchParams.get("paystate") !== null) {
      t.paystate = searchParams.get("paystate");
    }
    if (searchParams.get("begin_gte") !== null) {
      t.begin_gte = searchParams.get("begin_gte") + 'T00:00:00';
    }
    if (searchParams.get("end_lte") !== null) {
      t.end_lte = searchParams.get("end_lte") + 'T23:59:59';
    }
    return t;
  });
  useEffect(() => {
    if (walletsPending === false || _wallets.success === "") {
      return;
    }

    // this is necessary because it's called a second time without changing the wallets,
    // adding action state to react api end point should solve this issue
    if (areWalletsSame(_wallets.data, wallets)) return;

    if (_wallets.success === true) {
      if (_wallets.pagination.current_page == 1) {
        if (_wallets.data.length === 0 && Array.isArray(_wallets.data)) {
          // empty collection - store valid format with attributes "saldo" and "wallet_transactions"
          setWallets({
            saldo: 0,
            wallet_transactions: [],
          });
        } else {
          setWallets(_wallets.data);
        }
      } else {
        var clone = { ...wallets };
        clone.wallet_transactions = _wallets.data.wallet_transactions;
        clone.saldo = _wallets.data.saldo;
        setWallets(clone);
      }
      setPagination({ ..._wallets.pagination });
      // also fetch orders dependent on date
      props.dispatch(
        ordersActions.getOrders({
          token: Biscuit.get("token"),
          suffix: "",
          filter: getOrdersFilterByWallets(_wallets.data.wallet_transactions),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setOrdersPending(true);
    } else {
      console.log("Failed fetching wallets!");
    }
    setWalletsPending(false);
  }, [_wallets]);

  useEffect(() => {
    console.log("orders: ", _orders);
    if (ordersPending === false || _orders.success === "") {
      return;
    }

    if (
      typeof wallets.wallet_transactions === "undefined" ||
      typeof wallets.wallet_transactions.length === "undefined"
    )
      return;

    if (_orders.success === true) {
      // put orders into wallets, check for misssing orders for recently fetched wallets (current page)
      console.log("put orders into wallets");
      let wallet;
      for (var i = 0; i < wallets.wallet_transactions.length; i++) {
        wallet = wallets.wallet_transactions[i];
        if (typeof wallet.order === "undefined" || wallet.order === null) {
          for (var j = 0; j < _orders.data.length; j++) {
            if (wallet.order_id == _orders.data[j].id) {
              wallet.order = { ..._orders.data[j] };
              break;
            }
          }
        }
        if (typeof wallet.order === "undefined" || wallet.order === null) {
          console.log("order not found for wallet: ", wallet);
        }
      }
    } else {
      console.log("Failed fetching wallets!");
    }
    setOrdersPending(false);
  }, [_orders]);

  const loadNextPage = (page) => {
    //if (!pagination.has_next_page) return;

    setWalletsPending(true);

    let requestFilter = { ...filter };
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    requestFilter.limit = paginationLimit;
    requestFilter.page = page;

    // fetch next page
    props.dispatch(
      paymentsActions.getTransactions({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  const getOrdersFilterByWallets = (wallets) => {
    if (typeof wallets === "undefined" || wallets === null || wallets.length == 0) {
      return {
        limit: 100,
      };
    }

    //const firstWallet = wallets[0];
    //const lastWallet = wallets[wallets.length-1];
    //let lowest = moment('3000-01-01'), highest = moment();
    //for (var i=0;i<wallets.length;i++) {
    //     if (moment(wallets[i].created).isBefore(lowest,'second')) lowest = moment(wallets[i].created);
    //    if (moment(wallets[i].created).isAfter(highest,'second')) highest = moment(wallets[i].created);
    // }
    let lowest = 9999999999999999;
    let highest = 0;
    for (var i = 0; i < wallets.length; i++) {
      if (typeof wallets[i].order_nbr === "undefined" || wallets[i].order_nbr === null) continue;
      if (Number(wallets[i].order_nbr) > highest) highest = Number(wallets[i].order_nbr);
      if (Number(wallets[i].order_nbr) < lowest) lowest = Number(wallets[i].order_nbr);
    }
    console.log("lowest: ", lowest);
    console.log("highest: ", highest);

    return {
      limit: 999, // get all orders for filter values
      //created_gte: lastWallet.created,
      //created_lte: firstWallet.created
      //order_nbr_gte: lowest.format('YYYY-MM-DD HH:mm:ss'),
      //order_nbr_lte: highest.format('YYYY-MM-DD HH:mm:ss')
      order_nbr_gte: lowest,
      order_nbr_lte: highest,
    };
  };

  const areWalletsSame = (wallets1, wallets2) => {
    // check first / input wallet if empty
    if (wallets1.length === 0 && Array.isArray(wallets1)) {
      wallets1 = {
        saldo: 0,
        wallet_transactions: [],
      };
    }
    // check for invalid / empty transactions
    if (
      typeof wallets1.wallet_transactions === "undefined" ||
      typeof wallets2.wallet_transactions === "undefined"
    )
      return false;

    if (
      typeof wallets1.wallet_transactions.length === "undefined" ||
      typeof wallets2.wallet_transactions === "undefined"
    )
      return false;

    // check if data is equal
    if (wallets1.saldo != wallets2.saldo) return false;

    if (wallets1.wallet_transactions.length != wallets2.wallet_transactions.length) return false;

    for (var i = 0, wallet1, wallet2; i < wallets1.wallet_transactions.length; i++) {
      if (wallets1.wallet_transactions[i].id != wallets2.wallet_transactions[i].id) return false;
    }
    return true;
  };

  const getPreviousSaldo = (wallets) => {
    const currentSaldo =
      typeof wallets.saldo === "undefined" || wallets.saldo === null ? 0 : Number(wallets.saldo);

    let total = 0;

    if (typeof wallets.wallet_transactions === "undefined" || wallets.wallet_transactions === null)
      return currentSaldo;

    let wallet;
    for (var i = 0; i < wallets.wallet_transactions.length; i++) {
      wallet = wallets.wallet_transactions[i];
      if (Number(wallet.credit) > 0) total += Number(wallet.credit);
      if (Number(wallet.debit) > 0) total -= Number(wallet.debit);
    }

    return currentSaldo - total;
  };

  const filterChangedHandle = (filter) => {
    console.log("filter: ", filter);

    let requestFilter = { ...filter };
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }

    props.dispatch(
      paymentsActions.getTransactions({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setWalletsPending(true);
    setFilter(filter);
  };

  const onSortChangedHandle = (ev) => {
    const el = ev.currentTarget;

    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          page: 1,
        };
      }

      props.dispatch(
        paymentsActions.getTransactions({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setWalletsPending(true);
      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key, value) {
        key.classList.remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const onPrintClosingHandle = () => {
    if (pagination.has_next_page) {
      // show warning - not all transactions loaded
      if (!confirm(t("incomplete_transactions_warning"))) {
        return false;
      } else {
        printClosing(wallets);
        return false;
      }
    }
    printClosing(wallets);
    return false;
  };

  const searchBarHandler = (ev) => {
    let query;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      query = "";
    }
    searchParams.delete("p_reference");
    if (query !== "") {
      if (isNaN(Number(query))) {
        showNotification("warning", null, t("query must be number"));
        query = "";
        return;
      }
      searchParams.set("p_reference", query);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
    const minLength = 1;
    if (query.length >= minLength) {
      // work user search only for values bigger or equal to the minimum length
      if (allUrlParams?.initial !== undefined) {
        delete allUrlParams?.initial;
      }
      delete allUrlParams?.begin_gte;
      let filterA = {
        sort: "id",
        direction: "desc",
        page: 1,
        find: "full",
        limit: 40,
        ...allUrlParams,
      };

      setResetFilter(true);
      setTimeout(function () {
        let diff = Number(moment().format("x")) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value === query) {
          // no changes after the last 700 ms -> user finished input -> start request
          filterChangedHandle({
            ...filterA,
            p_reference: query,
          });
        }
      }, 800);
    } else if (filter.p_reference !== undefined) {
      // reset filter when query was active
      let clone = { ...filter };
      delete clone.p_reference;
      filterChangedHandle(clone);
    } else {
      filterChangedHandle(filterA);
    }
    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };
  const printClosing = (wallets) => {
    const today = moment(),
      location_id = filter.location_id;
    if (typeof filter.begin_gte !== "undefined") {
      let begin = moment(filter.begin_gte, "YYYY-MM-DD");
    }
    if (typeof filter.end_lte !== "undefined") {
      let end = moment(filter.end_lte, "YYYY-MM-DD");
    }

    let title = "";
    let type = t("closing", null, "capital");
    let dates = "";
    if (typeof end === "undefined") {
      if (typeof begin === "undefined") {
        title = t("closing");
        type = title;
      } else {
        title = t("day_closing").replace(" ", "_") + " " + begin.format("DDMMYYYY");
        type = t("day_closing", null, "capital");
        dates = begin.format("dd, DD.MM.YY");
      }
    } else {
      if (begin.format("dd, DD.MM.YY") === end.format("dd, DD.MM.YY")) {
        title = t("day_closing").replace(" ", "_") + " " + begin.format("DDMMYYYY");
        type = t("day_closing", null, "capital");
        dates = begin.format("dd, DD.MM.YY");
      } else {
        title = t("closing") + " " + begin.format("DDMMYYYY") + " - " + end.format("DDMMYYYY");
        dates = begin.format("dd, DD.MM.YY") + " - " + end.format("dd, DD.MM.YY");
        type = t("closing");
      }
    }
    let location_name = locationName;
    let transactionsByPaymentType = {};

    for (var i = 0, wallet; i < wallets.wallet_transactions.length; i++) {
      wallet = wallets.wallet_transactions[i];
      if (typeof transactionsByPaymentType[wallet.payment_type] === "undefined") {
        transactionsByPaymentType[wallet.payment_type] = [];
      }

      transactionsByPaymentType[wallet.payment_type].push(wallet);
    }
    /*
        _.each(transactionsCollection.models, (model) => {
            // Map transaction by payment type
    
            if (typeof transactionsByPaymentType[model.get('payment_type')] === 'undefined') {
                transactionsByPaymentType[model.get('payment_type')] = [];
            }
    
            transactionsByPaymentType[model.get('payment_type')].push(model);
        });
    */
    let totalPerDay = 0;

    const first_name = Biscuit.get("user.first_name"),
      last_name = Biscuit.get("user.last_name"),
      currency = Biscuit.get("client.currency");

    let output = `
            <html>
                <head>
                    <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                    <title>${title}</title>
                    <style type="text/css">
                        body { font-family: "Open Sans",Helvetica,Arial,sans-serif; }
                        hode, html, table, thead { width: 100%; }
                        h4 { font-size: 18px; }
                        .printSpacer { height:100px; }
                    </style>
                    </head>
                <body>
                    <p>
                        ${location_name}
                    </p>
                    <h4 style="float:left;">
                        ${type} 
                        ${dates}
                    </h4>
                    <p style="float:right;">
                        ${t("created_at")} 
                        ${today.format("DD.MM.YYYY, HH:mm")} 
                        ${t("edited_by")} 
                        ${first_name} ${last_name}
                    </p>
                    <br /><br />
    
                    <table class="before_print" style="margin-top:30px;">
                    <colgroup>
                        <col width="45%" />
                        <col width="55%" />
                    </colgroup>
                    <thead style="border-bottom:1px solid grey;">
                        <td>${t("payment_type", null, "capital")}</td>
                        <!--<td>${t("date", null, "capital")}</td>-->
                        <td style="text-align:right;">${t("amount", null, "capital")}</td>
                    </thead>
    
                    ${_.reduce(
                      transactionsByPaymentType,
                      function (memo, transactions, payment_type) {
                        let totalPerPaymentType = 0;

                        return (
                          memo +
                          `
                            <tr class="sub-headline" style="padding:30px 0;">
                                <td>
                                    <h3 style="padding-top:2px;margin-top:9px;">${payment_type === "null" ? t("misc") : payment_type}</h3>
                                </td>
                            ` +
                          _.reduce(
                            transactions,
                            function (_memo, transaction) {
                              const transactionPrice =
                                transaction.debit !== null || transaction.debit !== 0
                                  ? transaction.debit
                                  : -transaction.credit;

                              totalPerPaymentType += transactionPrice;
                              totalPerDay += transactionPrice;
                              totalPerPaymentType = Math.round(totalPerPaymentType, 2);
                              totalPerDay = Math.round(totalPerDay, 2);
                              return ""; /*_memo + `
                                <tr>
                                    <td>${transaction.get('id')}</td>
                                    <td>${transaction.get('payment_date')}</td>
                                    <td style="text-align:right;">${transactionPrice}${currency}</td>
                                    <!--<td>...</td>-->
                                </tr>`; */
                            },
                            "",
                          ) +
                          `
                            <td class="paragraph-sum-total" style="text-align:right;">
                                
                                    ${FormatHelper.currencyFormat(totalPerPaymentType)} ${currency}
                                    <br />
                            </td>
                        </tr>`
                        );
                      },
                      "",
                    )}
                        <tr class="paragraph-sum-total" style="text-align:right;">
                            <td></td>
                            <td>   
                                <br />
                                <hr />
                                ${t("payments_amount_total")}: 
                                <strong>${FormatHelper.currencyFormat(totalPerDay)} ${currency}</strong>
                                <br />
                                <hr />
                            </td>
                        </tr>
    
                        <tr class="paragraph-sum-total" style="position:absolute;">
                            <td>   
                                <br />
                                <br />
                                ${t("payments_bestand_ist")} ${today.format("DD.MM.YYYY, HH:mm")} ${t("o_clock")}:
                                <br />
                            </td>
                            <td></td>
                        </tr>
    
                        <tr>
                            <td>   
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                ${t("signature", null, "capital")}<br />
                                [${last_name}, ${first_name}]
                                <br />
                            </td>
                        <td></td>
                        </tr>
    
                        <tr>
                            <td>
                            <td style="text-align:right;color:grey;">
                                inbooma.net
                            </td>
                        </tr>
                    </table>
                </body>
            </html>`;

    let rV = -1; // Return value assumes failure.

    if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
      var uA = navigator.userAgent;
      var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

      if (rE.exec(uA) != null) {
        rV = parseFloat(RegExp.$1);
      } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      /*check for IE 11*/
        rV = 11;
      }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    // Trigger print command to browser
    const printWindow = window.open("", "", "height=700,width=674");

    printWindow.document.body.innerHTML = "";
    printWindow.document.body.innerHTML = output;

    if (rV >= 10 || isChrome) {
      printWindow.document.close(); // necessary for IE >= 10
      printWindow.focus(); // necessary for IE >= 10*
      printWindow.print();
    } else {
      // e.g. Firefox
      setTimeout(() => {
        printWindow.print();
        printWindow.opener.focus();
        printWindow.close();
      }, 0);
    }
  };

  const initialize = () => {
    if (initialized) return;
    props.dispatch(paymentsActions.getTransactionsResetData());
    props.dispatch(
      paymentsActions.getTransactions({
        token: Biscuit.get("token"),
        suffix: "",
        filter: filter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setInitialized(true);
    setWalletsPending(true);
  };

  initialize();

  const submenuItems = [
    {
      name: t("transactions", null, "capital"),
      link: "finances/transactions",
      data_inb_val: t("transactions", null, "capital"),
      icon: "fi fi-dollar",
      isActive: true,
      isAccessible: true,
    },
    {
      name: t("sales_billings", null, "capital"),
      link: "finances/sales_billings",
      data_inb_val: t("sales_billings", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: isViewVisible("salesBillings", "finances"),
    },
    {
      name: t("payment_accounts", null, "capital"),
      link: "finances/payment_accounts",
      data_inb_val: t("payment_accounts", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: false && isViewVisible("paymentAccounts", "finances"),
    },
    {
      name: t("insurances", null, "capital"),
      link: "finances/insurances",
      data_inb_val: t("insurances", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
    {
      name: t("admin transactions", null, "capital"),
      link: "finances/admin_transactions",
      data_inb_val: t("admin transactions", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
    {
      name: t("invoices", null, "capital"),
      link: "invoices",
      data_inb_val: t("invoices", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
  ];

  let tabs = [
    {
      name: t("date", null, "capital"),
      smallWidth: 3,
      mediumWidth: 3,
      title: t("sort_by_${a}", { a: t("date") }, "capital"),
      canSort: true,
      sort: {
        direction: "desc",
        data_inb_val: "payment_date",
      },
    },
    {
      name: t("order", null, "capital") + " / " + t("invoice"),
      smallWidth: 3,
      mediumWidth: 3,
      title: t("order", null, "capital") + " / " + t("invoice"),
      canSort: false,
    },
    {
      name: t("payment_type", null, "capital"),
      mediumWidth: 2,
      smallWidth: 2,
      title: t("payment_type", null, "capital"),
      canSort: false,
    },
    {
      name: t("payment_reference", null, "capital"),
      smallWidth: 2,
      mediumWidth: 2,
      title: t("payment_reference", null, "capital"),
      canSort: false,
    },
    {
      name: t("client_payment_amount", null, "capital"),
      smallWidth: 2,
      mediumWidth: 2,
      extraClasses: "text-right right",
      title: t("client_payment_amount", null, "capital"),
      canSort: false,
    },
  ];

  return (
    <>
      <TransactionsSidebar
        dispatch={props.dispatch}
        heading={t("transactions", null, "capital")}
        filterChangedHandle={filterChangedHandle}
        resetFilter={resetFilter}
        setResetFilter={setResetFilter}
        setLocationName={setLocationName}
      />
      <div id="inb-c-main" className="columns">
        <InboomaSubmenu
          tabs={submenuItems}
          searchbar={true}
          smallOnlyTitle={t("transactions", null, "capital")}
          searchbarPlaceholder={t("order_nbr")}
          searchbarValue={
            allUrlParamsClone?.p_reference !== undefined ? allUrlParamsClone.p_reference : ""
          }
          searchbarHandler={searchBarHandler}
        />
        <TransactionsTopBar
          textLeft={t("saldo_from_${a}", {
            a: filter.end_lte
              ? moment(filter.end_lte).format("DD.MM.YYYY")
              : moment().format("DD.MM.YYYY"),
          })}
          refLabel={t("closing_print")}
          amount={wallets.saldo}
          handler={onPrintClosingHandle}
        />
        <SortNav tabs={tabs} listStyle="tight" handler={onSortChangedHandle} />
        {initialized &&
          wallets?.wallet_transactions?.length > 0 &&
          !walletsPending &&
          typeof pagination !== "undefined" && (
            <Paginator
              pagination={pagination}
              itemsCountPerPage={paginationLimit}
              pageRangeDisplayed={5}
              onChange={loadNextPage}
            />
          )}
        {!walletsPending ? (
          <>
            {wallets?.wallet_transactions?.length > 0 ? (
              <>
                <TransactionsList wallets={wallets.wallet_transactions} dispatch={props.dispatch} />
                <TransactionsTopBar
                  textLeft={t("previous_saldo")}
                  refLabel=""
                  amount={getPreviousSaldo(wallets)}
                  handler={onPrintClosingHandle}
                />
              </>
            ) : (
              <>
                {" "}
                <div
                  id="inb-app-collection-empty"
                  className="inb-announcement"
                  style={{ minHeight: "1150px" }}
                >
                  <div className="inb-image-box">
                    <img alt="No Data" src={"assets/img/no_data.svg"} />
                  </div>
                  <h3>{t("app_msg_collection_empty")}</h3>
                  <p>{t("app_msg_collection_empty_body")}</p>
                </div>{" "}
              </>
            )}
          </>
        ) : (
          <>
            <div id="inb-app-collection-empty" className="inb-announcement">
              <div className="inb-image-box">
                <img className="rollingLoader colorize-black" src="assets/img/rolling_loader.svg" />
              </div>
            </div>{" "}
          </>
        )}
        {initialized &&
          wallets?.wallet_transactions?.length > 0 &&
          !walletsPending &&
          typeof pagination !== "undefined" && (
            <Paginator
              pagination={pagination}
              itemsCountPerPage={paginationLimit}
              pageRangeDisplayed={5}
              onChange={loadNextPage}
            />
          )}
      </div>
    </>
  );
};

export default TransactionsView;
